import { render, staticRenderFns } from "./energy_consumption.vue?vue&type=template&id=64f81845&scoped=true&"
import script from "./energy_consumption.vue?vue&type=script&lang=js&"
export * from "./energy_consumption.vue?vue&type=script&lang=js&"
import style0 from "./energy_consumption.vue?vue&type=style&index=0&id=64f81845&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f81845",
  null
  
)

export default component.exports